import { request } from '../../../modules/request';
import { Actions } from '../reducers';

export function ajaxLoginRequest(data, timeout = null) {
  return {
    url: `/terms/did_accept`,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: '*/*',
    },
    protectCSRF: true,
    timeout,
    data,
  };
}

export default function ajaxLogin(data) {
  const loginRequest = ajaxLoginRequest(data);
  return request(loginRequest)
    .then(Actions.ajaxLoginSuccess)
    .catch(() => Actions.internalFailure());
}
